import React, { useEffect, useState } from "react";
import { useCommsPropertiesQuery } from "apis/commsLog";
import { formatSydney } from "utils/commsLogStates";

// Shared by every admin action that starts with "which property?".
const PropertyPicker = ({ organizationId, onPick }) => {
  const [typed, setTyped] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => setSearch(typed.trim()), 300);
    return () => clearTimeout(timer);
  }, [typed]);

  const { data, isFetching } = useCommsPropertiesQuery({
    organizationId,
    days: 365,
    search: search || undefined,
    page: 1,
    limit: 10,
  });

  return (
    <div className="space-y-3">
      <label className="flex flex-col gap-1">
        <span className="text-xs text-darkgray">Which property?</span>
        <input
          autoFocus
          className="w-full rounded-md border border-mediumgray px-3 py-2 text-sm"
          placeholder="Search the address…"
          value={typed}
          onChange={(event) => setTyped(event.target.value)}
        />
      </label>
      <p className="text-xs text-darkgray">
        Searching the organisation selected on the comms log. Switch it there if the
        property is with another office.
      </p>
      <div className="divide-y divide-lightgray rounded-md border border-mediumgray">
        {!data.length ? (
          <p className="p-3 text-sm text-darkgray">
            {isFetching ? "Loading…" : "No properties match that address."}
          </p>
        ) : (
          data.map((row) => (
            <button
              key={String(row.propertyId)}
              type="button"
              className="flex w-full flex-col items-start px-3 py-2 text-left hover:bg-lightgray"
              onClick={() => onPick(row)}
            >
              <span className="text-sm">{row.address}</span>
              <span className="text-xs text-darkgray">
                {row.agentName || "No agent"} · {row.total} messages · last activity{" "}
                {formatSydney(row.lastActivityAt)}
              </span>
            </button>
          ))
        )}
      </div>
    </div>
  );
};

export default PropertyPicker;
